import { Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow } from '@material-ui/core';
import React from 'react';
import Card from '../../components/Card/Card.component';

interface Props {
    data: any[]
}

export default function RedemptionsTable({
    data
}: Props) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data?.length - page * rowsPerPage);

    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <TableContainer component={Card}>
            <Table aria-label="Points redemptions history">
                <TableHead>
                    <TableRow>
                        <TableCell>Bar name</TableCell>
                        <TableCell align="right"># of rewards</TableCell>
                        <TableCell align="right">Amount spent</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        data && (rowsPerPage > 0
                            ? data?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : data)
                            .map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell component="th" scope="row">
                                        {row.name}
                                    </TableCell>
                                    <TableCell align="right">{row.numberOfRewards}</TableCell>
                                    <TableCell align="right">${row.amountSpent}</TableCell>
                                </TableRow>
                            ))
                    }
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                            colSpan={3}
                            count={data?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                                inputProps: { 'aria-label': 'rows per page' },
                                native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    )
}
